import style from 'styled-components';

export const StyledBookingSuccess = style.section`
  text-align: center;
`;
